import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    Input,
    HostListener,
    ElementRef,
} from '@angular/core';
import {
    UserLocation,
    UserLocationToSave,
    SavedFilters,
    IHierachyFilterCacheUrlInfo,
    IStaffPosition,
    IHierachyFilterCache,
    IUserEmployee,
    PageLocationFilters,
    ILocationItem,
    IDddlSettings,
} from '../../interfaces/user-location';
import { FiltersService } from '../../services/filters.service';
import { ReusableFunctions } from '../../classes/reusable-functions';
import { ToastService } from '../../services/toast.service';
import { CurrentUserStateService } from '../../services/current-user-state.service';
import { Router } from '@angular/router';
import { HierarchyFiltersCustomOptions } from './hierarchy-filter-options/hierarchy-flters-custom-options';
import { MatDialog } from '@angular/material/dialog';
import { MainFiltersConfirmationDialogComponent } from '../main-filters-confirmation-dialog/main-filters-confirmation-dialog.component';

@Component({
    selector: 'main-filters',
    templateUrl: './main-filters.component.html',
    styleUrls: ['./main-filters.component.scss'],
})
export class MainFiltersComponent implements OnInit {
    filterChipsToDisplay: ILocationItem[] = [];
    savedFilters: SavedFilters[] = [];
    selectedSavedFilters: SavedFilters[] = [];
    settingsSavedFilters: IDddlSettings = {};
    locationFilterItems: UserLocation[] = [];
    selectedLocations: UserLocation[] = [];
    settingsLocations: IDddlSettings = {};
    isSaveFilterBtnDisabled = true;
    isApplyFilterBtnDisabled = true;
    tempLocations: UserLocation[] = [];
    filterSaveText: string;
    filterSavedErrorMsg = '';
    locationPointerEvent = 'auto';
    finalFiltersToPages = '';
    showFilterButton: boolean;
    allHierarchyCache: UserLocation[];
    hierarchyCachePageInfo: IHierachyFilterCacheUrlInfo;
    hierarchyCacheInfo: HierarchyFiltersCustomOptions;
    isFilterDialogOpen: boolean;
    isSaveFilterDialogOpen: boolean;
    filterSaveAsMethod: 'overrideExisting' | 'saveAsNew';
    saveAsNewFilter: boolean;
    isSaveFilterDialogBtnDisabled: boolean;

    @Output() filtersOutput: EventEmitter<string> = new EventEmitter<string>();
    @Input() readonly?: boolean;

    constructor(
        private _filterService: FiltersService,
        private _reusableFunctions: ReusableFunctions,
        private _toastService: ToastService,
        private _currentUserStateService: CurrentUserStateService,
        private _router: Router,
        public dialog: MatDialog,
        private elementRef: ElementRef
    ) {}

    ngOnInit() {
        if (this.readonly == null || this.readonly == undefined) {
            this.readonly = false;
        }

        this.isFilterDialogOpen = false;
        this.isSaveFilterDialogOpen = false;
        this.isSaveFilterDialogBtnDisabled = true;

        if (this.hideFilterButton()) {
            this.hierarchyCacheInfo = new HierarchyFiltersCustomOptions();
            let url = this._router.url.split('?')[0];
            this.hierarchyCachePageInfo = this.hierarchyCacheInfo.getHierarchyCachePageInfo(url);
            this.setCurrentFilters();
            this.settingsSavedFilters = this.setDdlSettings(
                'Saved Filters',
                'filterName',
                'savedFilterKey',
                6,
                true,
                true,
                false
            );
            this.settingsLocations = this.setDdlSettings(
                'Select Filter',
                'roleNameDisplay',
                'roleLevel',
                10,
                false,
                false,
                true
            );
            this.filterChipsToDisplay = this.updateFilterChips(this.selectedLocations);
            this.checkButtonDisabledStatus();
        }
    }

    getPageCache(): UserLocation[] {
        this.allHierarchyCache = this.hierarchyCacheInfo.getPageCache(
            this.hierarchyCachePageInfo.hierarchyGroupId,
            null
        );
        let pageCache: UserLocation[] = [];
        if (this.allHierarchyCache.length > 0) {
            if (this.hierarchyCachePageInfo.excludeEmployee) {
                pageCache = this.allHierarchyCache.filter((item) => item.isEmployee != true);
            } else {
                pageCache = this.allHierarchyCache;
            }
        }
        return pageCache;
    }

    setCurrentFilters() {
        this.selectedLocations = [];
        let currentFilters = this.getPageCache();
        if (currentFilters.length > 0) {
            currentFilters.forEach((item) => {
                let selectedLocationItem: UserLocation = {
                    isEmployee: item.isEmployee,
                    employeeSelectedItemArray: item.employeeSelectedItemArray,
                    originalEmployeeSelection: item.employeeSelectedItemArray,
                    roleLevel: item.roleLevel,
                    roleName: item.roleName,
                    originalSelection: item.roleSelectedItemArray,
                    roleSelectedItemArray: item.roleSelectedItemArray,
                    roleItemArray: [],
                    employeeArray: [],
                    roleNameDisplay: this.setRoleDisplayName(item),
                    isStaffPosition: item.isStaffPosition,
                    staffPositionArray: [],
                    staffPositionSelectedItemArray: item.staffPositionSelectedItemArray,
                };
                this.applyInnitialSettings(selectedLocationItem);

                if (selectedLocationItem.isStaffPosition) {
                    this._filterService.getPosition().subscribe((data) => {
                        selectedLocationItem.staffPositionArray = data;
                    });
                }
                this.selectedLocations.push(selectedLocationItem);
            });
            let levelList = this._reusableFunctions.getUniqueItemList(
                this.selectedLocations,
                'roleName'
            );
            let topLevel: UserLocation = this.getTopLevel(levelList)[2];
            this.populateTopLocationDetails(topLevel, false);
            this.updateSubDDLs(true, topLevel.roleLevel, topLevel);
        }
    }

    setRoleDisplayName(locInfo: UserLocation | UserLocationToSave) {
        let locInfoCopy = Object.assign({}, locInfo);
        let roleName = locInfoCopy.roleName;
        if (locInfo.isEmployee) {
            let defaultPosition = this.hierarchyCachePageInfo.defaultPosition;
            roleName = defaultPosition
                ? defaultPosition
                : !this.hierarchyCachePageInfo.excludeEmployee &&
                  !this.hierarchyCachePageInfo.showPosition
                ? 'Originator'
                : locInfoCopy.roleName;
        }
        return roleName;
    }

    hideFilterButton() {
        if (this._currentUserStateService.currentUser.userAccessLevel > 1) {
            this.showFilterButton = true;
            return true;
        }
        this.showFilterButton = false;
        return false;
    }

    filterButtonClick(event) {
        this.isFilterDialogOpen = !this.isFilterDialogOpen;
        if (this.isFilterDialogOpen) {
            this.getSavedFilters();
            //this.selectedSavedFilters = [];
            this._filterService
                .getUsersAllLocations(this.hierarchyCachePageInfo.employeeType)
                .subscribe(
                    (data) => this.setLocationData(data),
                    (error) => {
                        throw new Error(error);
                    }
                );
        }
    }

    getSavedFilters() {
        this._filterService.getSavedFilters().subscribe(
            (data) => {
                let savedFiltersDdlitems = [];
                data.forEach((savedFilterItem) => {
                    /*
                        NOTE: If the Hierarchy filters structure is significantly changed, 
                        the saved filters should be deleted from the database to avoid some isuues.
                    */
                    let savedFilters = this.hierarchyCacheInfo.getPageCache(
                        this.hierarchyCachePageInfo.hierarchyGroupId,
                        JSON.parse(savedFilterItem.filterString),
                        true
                    );
                    if (savedFilters && savedFilters.length > 0) {
                        savedFiltersDdlitems.push(savedFilterItem);
                    }
                });
                this.savedFilters = savedFiltersDdlitems;
            },
            (error) => {
                throw new Error(error);
            }
        );
    }

    setLocationData(data: UserLocation[]) {
        this.locationFilterItems = [];
        data.forEach((item) => {
            if (!(item.roleName === 'Employee' && this.hierarchyCachePageInfo.excludeEmployee)) {
                item.isEmployee = item.roleName === 'Employee';
                this.locationFilterItems.push({
                    roleName: item.roleName,
                    roleLevel: item.roleLevel,
                    roleNameDisplay: this.setRoleDisplayName(item),
                });
            }
        });
        this.locationFilterItems = this.locationFilterItems.sort((a, b) =>
            a.roleName.localeCompare(b.roleName)
        );
    }

    applyLocationsClick() {
        this.filterChipsToDisplay = this.updateFilterChips(this.selectedLocations);
        this.checkButtonDisabledStatus();
        this.saveHierarchyCache();
        this.finalFiltersToPages = this._reusableFunctions.getHierarchyFilters();
        this.isFilterDialogOpen = !this.isFilterDialogOpen;
        this.filtersOutput.emit(this.finalFiltersToPages);
    }

    saveHierarchyCache() {
        this.hierarchyCacheInfo.saveHierarchyFiltersToCache(
            this.getRequiredHierarchyItems(),
            this.hierarchyCachePageInfo.hierarchyGroupId
        );
    }

    getRequiredHierarchyItems() {
        let requiredLocationData = this.selectedLocations.map((obj) => ({
            ...obj,
        }));
        let minRequiredList = [];

        for (let loc of requiredLocationData) {
            minRequiredList.push({
                employeeSelectedItemArray: loc.employeeSelectedItemArray,
                roleSelectedItemArray: loc.roleSelectedItemArray,
                staffPositionSelectedItemArray: loc.staffPositionSelectedItemArray,
                isStaffPosition: loc.isStaffPosition,
                isEmployee: loc.isEmployee,
                roleLevel: loc.roleLevel,
                roleName: loc.roleName,
            });
        }
        return minRequiredList;
    }

    checkButtonDisabledStatus() {
        let isDirty = false;
        if (this.selectedLocations.length > 0) {
            this.isSaveFilterBtnDisabled = false;
            this.selectedLocations.forEach((item) => {
                if (
                    item.roleSelectedItemArray.length > 0 ||
                    item.employeeSelectedItemArray.length > 0
                ) {
                    isDirty = true;
                }
            });
        } else {
            this.isSaveFilterBtnDisabled = true;
        }

        if (isDirty || this.filterChipsToDisplay.length > 0) {
            this.isApplyFilterBtnDisabled = false;
        } else {
            this.isApplyFilterBtnDisabled = true;
        }
    }

    getEmptyAndNonEmptyLevels() {
        let firstEmptyLevel;
        let lastNonEmptyLevel;
        let lastNonEmptyWhenEmployeeNonEmpty;
        for (const location of this.selectedLocations) {
            const arrayNames = this.getArrayNames(location);

            if (location[arrayNames.selectArrayName].length > 0) {
                lastNonEmptyLevel = location.roleLevel;
            }

            if (location.isEmployee && location.employeeSelectedItemArray.length > 0) {
                let index = this.selectedLocations.findIndex(
                    (item) => item.roleLevel === location.roleLevel
                );
                lastNonEmptyWhenEmployeeNonEmpty = this.selectedLocations[index - 1].roleLevel;
            } else {
                lastNonEmptyWhenEmployeeNonEmpty = lastNonEmptyLevel;
            }

            if (location[arrayNames.selectArrayName].length === 0) {
                firstEmptyLevel = location.roleLevel;
                break;
            }
        }
        return [firstEmptyLevel, lastNonEmptyLevel, lastNonEmptyWhenEmployeeNonEmpty];
    }

    setInitialDisableStatus() {
        const firstEmptyLevel = this.getEmptyAndNonEmptyLevels()[0];
        for (const location of this.selectedLocations) {
            if (location.roleLevel === firstEmptyLevel) {
                const roleLevelList = this.getSortedRoleLevelList();
                const idx = roleLevelList.findIndex((item) => item === location.roleLevel);
                const topLocation = this.selectedLocations.find(
                    (item) => item.roleLevel === roleLevelList[idx - 1]
                );
                location.disableStatus = 'auto';

                if (topLocation) {
                    topLocation.disableStatus = 'auto';
                }
            } else {
                location.disableStatus = 'none';
            }
        }
    }

    setindividualDdlDisableStatus(roleLevelAtChange) {
        const roleLevelList = this.getSortedRoleLevelList();
        const idx = roleLevelList.findIndex((item) => item === roleLevelAtChange);
        const topLocation = this.selectedLocations.find(
            (item) => item.roleLevel === roleLevelList[idx - 1]
        );
        const nextLocation = this.selectedLocations.find(
            (item) => item.roleLevel === roleLevelList[idx + 1]
        );
        const currLocation = this.selectedLocations.find(
            (item) => item.roleLevel === roleLevelAtChange
        );
        const arrayNames = this.getArrayNames(currLocation);

        currLocation.disableStatus = 'auto';
        if (currLocation[arrayNames.selectArrayName].length > 0) {
            if (nextLocation) {
                nextLocation.disableStatus = 'auto';
            }
            if (topLocation) {
                topLocation.disableStatus = 'none';
            }
        } else {
            if (nextLocation) {
                nextLocation.disableStatus = 'none';
            }
            if (topLocation) {
                topLocation.disableStatus = 'auto';
            }
        }
    }

    updateFilterChips(selectedLocations) {
        const locationSubFiters: ILocationItem[] = [];

        for (const location of selectedLocations) {
            if (location.isEmployee && !this.hierarchyCachePageInfo.excludeEmployee) {
                if (location.employeeSelectedItemArray.length > 0) {
                    const subLocations = location.employeeSelectedItemArray.sort((a, b) =>
                        this._reusableFunctions.sortAlphaNumeric(a.employee, b.employee)
                    );

                    for (const subLocation of subLocations) {
                        locationSubFiters.push({
                            roleLevel: location.roleLevel,
                            roleName: location.roleName,
                            chipName: subLocation.employee,
                            hierarchyName: undefined,
                            hierarchyIdentifier: undefined,
                            employeeIdentifier: subLocation.employeeIdentifier,
                            employee: subLocation.employee,
                            isSubFilter: true,
                            isEmployee: location.isEmployee,
                            disableStatus: 'auto',
                        });
                    }
                }
            } else if (!location.isEmployee) {
                if (location.roleSelectedItemArray.length > 0) {
                    const subLocations = location.roleSelectedItemArray.sort((a, b) =>
                        this._reusableFunctions.sortAlphaNumeric(a.hierarchyName, b.hierarchyName)
                    );

                    for (const subLocation of subLocations) {
                        locationSubFiters.push({
                            roleLevel: subLocation.roleLevel,
                            roleName: subLocation.roleName,
                            chipName: subLocation.hierarchyName,
                            hierarchyName: subLocation.hierarchyName,
                            hierarchyIdentifier: subLocation.hierarchyIdentifier,
                            employeeIdentifier: subLocation.employeeIdentifier,
                            employee: subLocation.employee,
                            isSubFilter: true,
                            isEmployee: location.isEmployee,
                            disableStatus: subLocation.disableStatus,
                        });
                    }
                }
            }
        }
        return locationSubFiters;
    }

    getSortedRoleLevelList(): Array<any> {
        return this._reusableFunctions
            .getUniqueItemList(this.selectedLocations, 'roleLevel')
            .sort((a, b) => b - a);
    }

    setDdlSettings(
        filterDefaultText: string,
        labelKey: string,
        primaryKey: string,
        showLimit: number,
        singleSelection = false,
        enableSearch = true,
        showCheckbox = true,
        enableFilterSelectAll = false
    ): IDddlSettings {
        return Object.assign(
            {},
            {
                singleSelection: singleSelection,
                text: filterDefaultText,
                selectAllText: 'Select All',
                unSelectAllText: 'Deselect All',
                filterUnSelectAllText: 'Deselect all filtered results',
                enableSearchFilter: enableSearch,
                badgeShowLimit: showLimit,
                enableCheckAll: enableFilterSelectAll,
                labelKey: labelKey,
                primaryKey: primaryKey,
                classes: '',
                showCheckbox: showCheckbox,
                disabled: false,
                position: 'bottom',
                noDataLabel: 'No results found',
            }
        );
    }

    getTopLevel(levelsList: Array<any>): Array<any> {
        let topLevelName = '';
        let topLevelNumber = 0;
        let topLevel: UserLocation;

        for (const levelName of levelsList) {
            const location = this.selectedLocations.find((item) => item.roleName === levelName);
            if (location) {
                const level = location.roleLevel;
                if (level > topLevelNumber) {
                    topLevelNumber = level;
                    topLevelName = location.roleName;
                    topLevel = location;
                }
            }
        }
        return [topLevelName, topLevelNumber, topLevel];
    }

    updateSubDDLs(
        isMainFilter: boolean,
        levelAtChange: any,
        roleInfo: UserLocation,
        isChipClic = false
    ) {
        let roleLevelAtChange = parseInt(levelAtChange.toString());
        const roleLevelList = this.getSortedRoleLevelList();
        const index = roleLevelList.findIndex(
            (item) => item.toString() === roleLevelAtChange.toString()
        );
        let roleLevelBefore = 0;

        if (roleLevelList[0]) {
            if (roleLevelAtChange.toString() === roleLevelList[0].toString()) {
                roleLevelBefore = parseInt(roleLevelList[0].toString());
            } else {
                if (index < 0) {
                    for (let level of roleLevelList) {
                        if (level.toString() > roleLevelAtChange.toString()) {
                            roleLevelBefore = parseInt(level.toString());
                        }
                    }
                } else {
                    roleLevelBefore = parseInt(roleLevelList[index - 1].toString());
                }
            }

            if (isMainFilter) {
                if (roleLevelAtChange.toString() === roleLevelList[0].toString() || index < 0) {
                    roleLevelAtChange = parseInt(roleLevelList[0].toString());
                } else {
                    roleLevelAtChange = parseInt(roleLevelList[index - 1].toString());
                }
            }
        }

        this.tempLocations = [];

        for (const loc of this.selectedLocations) {
            loc.originalSelection = loc.roleSelectedItemArray;
            loc.originalEmployeeSelection = loc.employeeSelectedItemArray;

            if (loc.roleLevel.toString() < roleLevelAtChange.toString()) {
                this.tempLocations.push({
                    roleName: loc.roleName,
                    roleItemArray: [],
                    roleSelectedItemArray: [],
                    employeeArray: [],
                    employeeSelectedItemArray: [],
                    roleLevel: loc.roleLevel,
                    roleNameDisplay: this.setRoleDisplayName(loc),
                    staffPositionArray: [],
                    staffPositionSelectedItemArray: [],
                });
            }
        }

        let hasEmployeeDdl = this.selectedLocations.find((item) => item.isEmployee) ? true : false;
        let locationCount = 0;
        let isFilterServiceCalled = false;
        for (const selection of this.selectedLocations) {
            locationCount += 1;

            if (selection.roleLevel.toString() <= roleLevelBefore.toString()) {
                if (selection.roleSelectedItemArray.length > 0 && !selection.isEmployee) {
                    selection.roleSelectedItemArray.sort((a, b) =>
                        this._reusableFunctions.sortAlphaNumeric(a.hierarchyName, b.hierarchyName)
                    );

                    let count = 0;
                    for (const loc of selection.roleSelectedItemArray) {
                        isFilterServiceCalled = true;

                        this._filterService
                            .getSubLocationDetails(selection.roleName, loc.hierarchyIdentifier)
                            .subscribe(
                                (subLocations) => {
                                    count += 1;
                                    const uniqueRoleNames =
                                        this._reusableFunctions.getUniqueItemList(
                                            subLocations,
                                            'roleName'
                                        );
                                    const topLevelName = this.getTopLevel(uniqueRoleNames);
                                    const selected = subLocations.filter(
                                        (item) => item.roleName === topLevelName[0]
                                    );
                                    const tempLoc = this.tempLocations.find(
                                        (item) => item.roleName === topLevelName[0]
                                    );

                                    if (tempLoc) {
                                        tempLoc.roleItemArray =
                                            tempLoc.roleItemArray.concat(selected);
                                        tempLoc.roleItemArray = tempLoc.roleItemArray.sort((a, b) =>
                                            this._reusableFunctions.sortAlphaNumeric(
                                                a.hierarchyName,
                                                b.hierarchyName
                                            )
                                        );
                                    }

                                    let lastNonEmptyLevel = this.getEmptyAndNonEmptyLevels()[2];

                                    if (selection.roleSelectedItemArray.length === count) {
                                        this.setFilterOptionList();
                                        if (selection.roleLevel === lastNonEmptyLevel) {
                                            if (hasEmployeeDdl) {
                                                this.setEmployeesDdl(roleInfo, isChipClic);
                                            } else if (isChipClic) {
                                                this.applyLocationsClick();
                                            }
                                        }
                                    }
                                },
                                (error) => {
                                    throw new Error(error);
                                }
                            );
                    }
                } else {
                    this.resetBottomDdls(selection.roleLevel);
                    if (
                        isChipClic &&
                        this.selectedLocations.length === locationCount &&
                        !isFilterServiceCalled &&
                        selection.employeeSelectedItemArray.length === 0
                    ) {
                        this.applyLocationsClick();
                    }
                }

                if (
                    isChipClic &&
                    selection.isEmployee &&
                    selection.employeeSelectedItemArray.length > 0 &&
                    selection.roleLevel.toString() === roleLevelAtChange.toString() &&
                    !isFilterServiceCalled
                ) {
                    this.setEmployeesDdl(roleInfo, isChipClic);
                }
            }
        }
    }

    resetBottomDdls(roleLevel) {
        for (const location of this.selectedLocations) {
            if (location.roleLevel < roleLevel) {
                location.roleItemArray = [];
                location.employeeArray = [];
                location.roleSelectedItemArray = [];
                location.employeeSelectedItemArray = [];
            }
        }
    }

    setEmployeesDdl(roleInf: UserLocation, isChipClic = false) {
        let employeeDdlInfo = this.selectedLocations.find((item) => item.isEmployee === true);
        const selectedVals = this.getPreFilterToGetEmployees();
        if (employeeDdlInfo && employeeDdlInfo.isEmployee && !employeeDdlInfo.isHidden) {
            if (employeeDdlInfo.isStaffPosition) {
                let staffInf = employeeDdlInfo.staffPositionSelectedItemArray[0];
                if (staffInf) {
                    this._filterService
                        .getEmployeeByPosition(
                            JSON.stringify(selectedVals),
                            staffInf.staffingKey.toString(),
                            this.hierarchyCachePageInfo?.filterType
                        )
                        .subscribe(
                            (data) => {
                                this.updateEmployeeDdl(employeeDdlInfo, data, isChipClic);
                            },
                            (error) => {
                                throw new Error(error);
                            }
                        );
                }
            } else {
                let isEmployeeTopLevel = false;
                if (this.selectedLocations.length == 1) {
                    isEmployeeTopLevel = true;
                }
                this._filterService
                    .getEmployeeDetails(
                        JSON.stringify(selectedVals),
                        isEmployeeTopLevel,
                        this.hierarchyCachePageInfo.employeeType
                    )
                    .subscribe(
                        (data) => {
                            this.updateEmployeeDdl(employeeDdlInfo, data.employeeData, isChipClic);
                        },
                        (error) => {
                            throw new Error(error);
                        }
                    );
            }
        }
    }

    updateEmployeeDdl(loc: UserLocation, data: IUserEmployee[], isChipClic: boolean) {
        this.setLocationItems(data, loc, false);
        loc.employeeSelectedItemArray.sort((a, b) =>
            this._reusableFunctions.sortAlphaNumeric(a.employee, b.employee)
        );
        if (isChipClic) {
            this.applyLocationsClick();
        }
    }

    getPreFilterToGetEmployees(): PageLocationFilters[] {
        let lowestLocationWithSelection: UserLocation = {
            roleName: '',
        };
        const employeeFilters: PageLocationFilters[] = [];

        for (const location of this.selectedLocations) {
            if (location.roleSelectedItemArray && !location.isEmployee) {
                lowestLocationWithSelection = location;
            }
        }

        if (lowestLocationWithSelection.roleSelectedItemArray) {
            for (const subLoc of lowestLocationWithSelection.roleSelectedItemArray) {
                employeeFilters.push({
                    Hierarchy: {
                        rolename: lowestLocationWithSelection.roleName,
                        hierarchyidentifier: subLoc.hierarchyIdentifier,
                    },
                });
            }
        }
        return employeeFilters;
    }

    setFilterOptionList() {
        for (const tempLocation of this.tempLocations) {
            const locationDetails = this.selectedLocations.find(
                (item) => item.roleName === tempLocation.roleName
            );
            locationDetails.roleItemArray = tempLocation.roleItemArray.sort((a, b) =>
                this._reusableFunctions.sortAlphaNumeric(a.hierarchyName, b.hierarchyName)
            );
            locationDetails.roleSelectedItemArray = tempLocation.roleSelectedItemArray;
            if (locationDetails.roleItemArray.length === 0) {
                locationDetails.roleSelectedItemArray = [];
            }
            this.checkCurrentSelectionInAvailableList(locationDetails);
        }
    }

    populateTopLocationDetails(event: UserLocation, hideDDl: boolean) {
        let roleLevelList = [];
        roleLevelList = this.getSortedRoleLevelList();
        const topRole = this.selectedLocations.find((loc) => loc.roleLevel === roleLevelList[0]);

        if (topRole) {
            if (topRole.isEmployee) {
                this.setEmployeesDdl(topRole);
            } else {
                this._filterService.getLocationDetails(topRole.roleName).subscribe(
                    (data) => this.setLocationItems(data, topRole, false),
                    (error) => {
                        throw new Error(error);
                    }
                );
            }
            this.selectedLocations.sort((a, b) => b.roleLevel - a.roleLevel);
        }
    }

    getDefaultText(loc: UserLocation) {
        let roleDisplayName = this.setRoleDisplayName(loc);
        return 'Select ' + this._reusableFunctions.toCamelCase(roleDisplayName);
    }

    setLocationItems(data: Array<any>, userLocation: UserLocation, hideDDl: boolean) {
        if (this.selectedLocations.length > 0) {
            const selectedLocation = this.selectedLocations.find(
                (obj) => obj.roleName === userLocation.roleName
            );

            if (!hideDDl) {
                if (userLocation.isEmployee) {
                    let roleName = '';
                    if (userLocation.isStaffPosition) {
                        roleName = userLocation.staffPositionSelectedItemArray[0].position;
                    } else {
                        roleName = this.setRoleDisplayName(userLocation);
                    }

                    const ddlDefaultText =
                        'Select ' + this._reusableFunctions.toCamelCase(roleName);
                    selectedLocation.employeeArray = data;
                    this.setEmployeeDdlSetting(selectedLocation, ddlDefaultText);

                    for (let emp of selectedLocation.employeeArray) {
                        emp.roleName = userLocation.roleName;
                    }
                    this.checkCurrentSelectionInAvailableList(selectedLocation);
                } else {
                    selectedLocation.roleItemArray = data;
                    selectedLocation.roleItemArray.sort((a, b) =>
                        this._reusableFunctions.sortAlphaNumeric(a.hierarchyName, b.hierarchyName)
                    );
                }
                selectedLocation.isHidden = hideDDl;
                this.selectedLocations.sort((a, b) => b.roleLevel - a.roleLevel);
            }
        }
    }

    getArrayNames(locationDetails: UserLocation | ILocationItem) {
        let arrayNames = {
            selectArrayName: 'roleSelectedItemArray',
            mainArrayName: 'roleItemArray',
            hierarchyId: 'hierarchyIdentifier',
            originalSelection: 'originalSelection',
        };

        if (locationDetails.isEmployee) {
            arrayNames = {
                selectArrayName: 'employeeSelectedItemArray',
                mainArrayName: 'employeeArray',
                hierarchyId: 'employeeIdentifier',
                originalSelection: 'originalEmployeeSelection',
            };
        }
        return arrayNames;
    }

    checkCurrentSelectionInAvailableList(locationDetails: UserLocation) {
        const arrayNames = this.getArrayNames(locationDetails);
        let selectArray = locationDetails[arrayNames.selectArrayName];
        const mainArray = locationDetails[arrayNames.mainArrayName];
        const originalSelectArray = locationDetails[arrayNames.originalSelection];
        let tempSelect: any[] = [];

        if (mainArray.length > 0) {
            if (selectArray.length === 0 && originalSelectArray.length > 0) {
                selectArray = originalSelectArray;
            }

            tempSelect = this.getCommonItemsFrom2Arrays(
                mainArray,
                selectArray,
                arrayNames.hierarchyId
            );
        } else {
            this.resetBottomDdls(locationDetails.roleLevel);
        }
        locationDetails[arrayNames.selectArrayName] = tempSelect;
    }

    getCommonItemsFrom2Arrays(mainArray, selectArray, hierarchyId) {
        const tempSelect: any[] = [];
        for (const sele of selectArray) {
            for (const main of mainArray) {
                if (sele[hierarchyId] === main[hierarchyId]) {
                    tempSelect.push(sele);
                }
            }
        }
        return tempSelect;
    }

    initializeLocationObject(location: UserLocation) {
        if (location) {
            location.employeeSelectedItemArray = [] as IUserEmployee[];
            location.roleSelectedItemArray = [] as ILocationItem[];
            location.roleItemArray = [] as ILocationItem[];
            location.employeeArray = [] as IUserEmployee[];
            location.staffPositionArray = [];
            location.staffPositionSelectedItemArray = [];
            this.applyInnitialSettings(location);
        }
    }

    setEmployeeDdlSetting(location: UserLocation, ddlDefaultText: string) {
        let addSelectAllBtn = false;
        let enableSearch = false;
        if (location && location.employeeArray && location.employeeArray.length > 15) {
            enableSearch = true;
            addSelectAllBtn = true;
        }

        location.settings = this.setDdlSettings(
            ddlDefaultText,
            'employee',
            'employeeIdentifier',
            4,
            false,
            enableSearch,
            true,
            addSelectAllBtn
        );
    }

    applyInnitialSettings(location: UserLocation) {
        let roleDisplayName = this.setRoleDisplayName(location);
        const ddlDefaultText = 'Select ' + this._reusableFunctions.toCamelCase(roleDisplayName);
        this.setEmployeeDdlSetting(location, ddlDefaultText);

        if (location.roleLevel == 1) {
            location.isEmployee = true;

            location.isStaffPosition = this.hierarchyCachePageInfo.showPosition;
            if (location.isStaffPosition) {
                location.staffpositionDdlSettings = this.setDdlSettings(
                    'Select Position',
                    'position',
                    'staffingKey',
                    4,
                    true,
                    false,
                    false
                );
            }
        } else {
            location.isEmployee = false;
            location.settings = this.setDdlSettings(
                ddlDefaultText,
                'hierarchyName',
                'hierarchyIdentifier',
                4
            );
        }
    }

    onMainFilterChange(event: UserLocation) {
        this.initializeLocationObject(event);
        let roleDisplayName = this.setRoleDisplayName(event);
        if (event.isStaffPosition) {
            this._filterService.getPosition().subscribe((data) => {
                event.staffPositionArray = data;
                let defaultPosition = data.find(
                    (item) => item.position.toLowerCase() === roleDisplayName.toLowerCase()
                );
                if (defaultPosition) {
                    event.staffPositionSelectedItemArray = [defaultPosition];
                    const ddlDefaultText =
                        'Select ' +
                        this._reusableFunctions.toCamelCase(defaultPosition.position ?? '');
                    this.setEmployeeDdlSetting(event, ddlDefaultText);
                } else {
                    event.staffPositionSelectedItemArray = [];
                }
                this.collectiveRun(event);
            });
        } else {
            this.collectiveRun(event);
        }
    }

    collectiveRun(loc: UserLocation) {
        this.populateTopLocationDetails(loc, false);
        this.updateSubDDLs(true, loc.roleLevel, loc);
        this.checkButtonDisabledStatus();
    }

    onItemSelectSavedFilters(event: SavedFilters) {
        if (!event.isDeleting) {
            let savedFilters = this.hierarchyCacheInfo.getPageCache(
                this.hierarchyCachePageInfo.hierarchyGroupId,
                JSON.parse(event.filterString),
                true
            );

            let tempSelectedLocations: UserLocation[] = [];
            const uniqueRoleLevels = this._reusableFunctions.getUniqueItemList(
                savedFilters,
                'roleLevel'
            );
            for (let loc of savedFilters) {
                let roleDisplayName = this.setRoleDisplayName(loc);
                let locationItems: UserLocation = {
                    roleLevel: loc.roleLevel,
                    roleName: loc.roleName,
                    isEmployee: loc.isEmployee,
                    roleSelectedItemArray: loc.roleSelectedItemArray,
                    originalSelection: [],
                    employeeSelectedItemArray: loc.employeeSelectedItemArray,
                    originalEmployeeSelection: [],
                    employeeArray: [],
                    roleItemArray: [],
                    isHidden: false,
                    disableStatus: 'auto',
                    roleNameDisplay: roleDisplayName,
                    isStaffPosition: loc.isStaffPosition,
                    staffPositionArray: [],
                    staffPositionSelectedItemArray: loc.staffPositionSelectedItemArray,
                };

                this.applyInnitialSettings(locationItems);

                if (loc.isEmployee && loc.isStaffPosition) {
                    this._filterService.getPosition().subscribe((data) => {
                        locationItems.staffPositionArray = data;
                    });
                }
                tempSelectedLocations.push(locationItems);
            }
            if (tempSelectedLocations.length > 0) {
                this.selectedLocations = tempSelectedLocations;
                this.populateTopLocationDetails(this.selectedLocations[0], false);
                this.updateSubDDLs(true, uniqueRoleLevels[0], this.selectedLocations[0]);
                this.checkButtonDisabledStatus();
            }
        }
    }

    onItemDeSelectSavedFilters(event) {
        this.checkButtonDisabledStatus();
    }

    onSelectAll(event) {
        this.checkButtonDisabledStatus();
    }
    onDeSelectAll(event) {
        this.checkButtonDisabledStatus();
    }

    onSubFilterChange(
        event: IStaffPosition | ILocationItem,
        roleInfo: UserLocation,
        elementId: string,
        isEmpPositionChanged = false
    ) {
        if (roleInfo.isStaffPosition && isEmpPositionChanged) {
            roleInfo.staffPositionSelectedItemArray = [event as IStaffPosition];
            this.setEmployeesDdl(roleInfo);
        } else {
            this.updateSubDDLs(false, roleInfo.roleLevel, roleInfo);
        }
        this.checkButtonDisabledStatus();
        this.setContainerHeightByItemsSelected(elementId);
    }

    chipIconClick(chip: ILocationItem) {
        let loc = this.selectedLocations.find((item) => item.roleName === chip.roleName);
        if (chip.isSubFilter) {
            const arrayNames = this.getArrayNames(chip);
            loc[arrayNames.selectArrayName] = loc[arrayNames.selectArrayName].filter(
                (item) => item[arrayNames.hierarchyId] !== chip[arrayNames.hierarchyId]
            );
        }

        if (this.filterChipsToDisplay.length === 0) {
            this.selectedLocations = [];
            this.applyLocationsClick();
        } else {
            this.updateSubDDLs(!chip.isSubFilter, loc.roleLevel, loc, true);
        }
    }

    getSelectedSavedFilterName() {
        return this.selectedSavedFilters[0]?.filterName ?? '';
    }

    checkSaveFilterDialogBtnStatus() {
        this.isSaveFilterDialogBtnDisabled = !(
            this.filterSaveAsMethod === 'overrideExisting' ||
            (this.filterSaveText && this.filterSaveText.length > 0)
        );
    }

    saveSelectedFilters() {
        let hierarchyCachePlaceHolder: IHierachyFilterCache;
        let hierarchyCache = this.hierarchyCacheInfo.setHierarchyFiltersToSave(
            this.getRequiredHierarchyItems(),
            hierarchyCachePlaceHolder,
            this.hierarchyCachePageInfo.hierarchyGroupId
        );

        let overrideExistingSavedFilters = this.filterSaveAsMethod === 'overrideExisting';
        let filterSaveName = overrideExistingSavedFilters
            ? this.getSelectedSavedFilterName()
            : this.filterSaveText;

        this._filterService
            .saveSelectedFilters(
                filterSaveName,
                JSON.stringify(hierarchyCache),
                overrideExistingSavedFilters
            )
            .subscribe(
                (success) => {
                    if (success > 0) {
                        this.filterSavedErrorMsg = '';
                        this._toastService.success('Filters are saved successfully!');
                        this.isSaveFilterDialogOpen = !this.isSaveFilterDialogOpen;
                    } else {
                        this.filterSavedErrorMsg = 'Please recheck your entry';
                    }
                },
                (error) => {
                    throw new Error(error);
                }
            );
    }

    cancelSaveFilters() {
        this.filterSavedErrorMsg = '';
        this.getSavedFilters();

        this.isSaveFilterDialogOpen = !this.isSaveFilterDialogOpen;
        this.isFilterDialogOpen = !this.isFilterDialogOpen;
    }

    setContainerHeightByItemsSelected(elementId: string) {
        let ddlArea = document.getElementById(elementId);
        if (ddlArea) {
            let inputArea = ddlArea.getElementsByClassName('selected-list').item(0);
            let inputAreaDdl = ddlArea.getElementsByClassName('dropdown-list').item(0);
            if (inputArea) {
                ddlArea.style.paddingBottom =
                    inputAreaDdl.clientHeight + inputArea.clientHeight + 55 + 'px';
            }
        }
    }

    setContainerHeight(
        elementId: string,
        isOpen: boolean,
        arrayLength: number,
        isSearchBox = false,
        isSelectAllBox = false
    ) {
        let ddlArea = document.getElementById(elementId);
        if (ddlArea) {
            let inputArea = ddlArea.getElementsByClassName('selected-list').item(0);
            if (isOpen) {
                if (inputArea) {
                    // TODO: this can be more simplified; see setContainerHeightByItemsSelected method
                    let heightSearchBox = isSearchBox ? 76 : 0;
                    heightSearchBox = isSelectAllBox ? heightSearchBox + 38 : heightSearchBox;
                    let height1ListItem = 38;
                    let heightMoreThan6Items = heightSearchBox + 6 * height1ListItem;
                    let heightLessthan6Items = heightSearchBox + arrayLength * height1ListItem;
                    let heightNoItems = 60 + heightSearchBox;
                    let heightAdjustment = inputArea.clientHeight - 20;
                    ddlArea.style.paddingBottom =
                        (arrayLength === 0
                            ? heightNoItems
                            : arrayLength > 5
                            ? heightMoreThan6Items + heightAdjustment
                            : heightLessthan6Items + heightAdjustment) + 'px';
                }
            } else {
                setTimeout(() => {
                    ddlArea.style.paddingBottom = '0px';
                }, 100);
            }
        }
    }

    clearAllSelection() {
        this.selectedLocations = [];
        this.applyLocationsClick();
    }

    clearAllUnappliedFilters() {
        if (this.filterChipsToDisplay.length > 0) {
            this.clearAllSelection();
        } else {
            this.selectedLocations = [];
        }
        this.isSaveFilterBtnDisabled = true;
        this.selectedSavedFilters = [];
    }

    filterSaveBtnClick() {
        this.filterSaveText = '';
        this.filterSavedErrorMsg = '';
        this.isFilterDialogOpen = !this.isFilterDialogOpen;
        this.isSaveFilterDialogOpen = !this.isSaveFilterDialogOpen;
    }

    savedItemDelete(filterItem: SavedFilters) {
        const dialogRef = this.dialog.open(MainFiltersConfirmationDialogComponent, {
            id: 'alert-dialog',
            data: {
                title: 'Delete filter?',
                message: 'Are you sure you want to delete the saved filter ${itemName}?'.replace(
                    '${itemName}',
                    filterItem.filterName
                ),
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'accept') {
                filterItem.isDeleting = true;
                this._filterService.deleteSavedFilters(filterItem.savedFilterKey).subscribe(
                    (success) => {
                        if (success > 0) {
                            this.selectedSavedFilters = [];
                            this._toastService.success(
                                filterItem.filterName + ' was deleted successfully!'
                            );
                            this.savedFilters = this.savedFilters.filter(
                                (item) => item.savedFilterKey !== filterItem.savedFilterKey
                            );
                        } else {
                            this._toastService.warningAlert(
                                'Something went wrong. Please try again.'
                            );
                            filterItem.isDeleting = false;
                        }
                    },
                    (error) => {
                        throw new Error(error);
                    }
                );
            }
        });
    }

    filterMouseLeaveEvent() {
        setTimeout(() => {}, 2000);
    }

    showSaveAsSelectedFiltersOptions() {
        let isSavedFilterSelected = this.selectedSavedFilters?.length > 0;
        this.saveAsNewFilter = this.filterSaveAsMethod === 'saveAsNew' || !isSavedFilterSelected;
        return isSavedFilterSelected;
    }

    @HostListener('document:mousedown', ['$event'])
    onClick(event: MouseEvent) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isFilterDialogOpen = false;
            this.isSaveFilterDialogOpen = false;
        }
    }

    convertToCamelcase(roleNameDisplay: string) {
        return this._reusableFunctions.toCamelCase(roleNameDisplay);
    }
}
